AppTabs.createTab( {

	name: 'import-results',
	icon: 'upload',
	text: 'Import Results',
	//preload: 'vmImportResults',
	create: function(init) {
		'use strict'
	
		function coalesce( a, b, c = null ) {
			return a !== null && typeof a != 'undefined'
				? a
				: b !== null && typeof b != 'undefined'
				? b
				: c !== null && typeof b != 'undefined'
				? c
				: null;
		}
		function emptyCoalesce( a, b, c = null ) {
			return a !== null && typeof a != 'undefined' && (typeof a != 'string' || a != '')
				? a
				: b !== null && typeof b != 'undefined' && (typeof b != 'string' || b != '')
				? b
				: c !== null && typeof b != 'undefined' && (typeof c != 'string' || c != '')
				? c
				: null;
		}
		function makeKey( { SampleNumber, TestID, Method, Analyte } ) {
			return JSON.stringify( { SampleNumber, TestID, Method, Analyte } );
		}
		function getFieldByIndex( row, index, fallback = null ) {
			return index !== null && row.length > index ? row[ index ] : fallback;
		}
		function parseIndex( value ) {
			value = parseInt( value );
			return isNaN( value ) ? null : value;
		}
		function excelFieldToDate( value ) {
			if ( value == null || value == '' ) { return null; }
			if ( typeof value == 'string' ) {
				value = new Date( Date.parse( value ) );
			} else if ( typeof value == 'number' ) {
				value = new Date(0, 0, value - 1, 0, 0, 0);
			} else if ( ! ( value instanceof Date ) ) {
				console.error( 'excelFieldToDate invalid input', value );
				return value;
			}
			return value && ! isNaN( value ) ? getLocalISODate(value) : null;
		}
		const normalizeNumber = function(value) {
			if ( value === '' || value === undefined ) { return null; }
			if ( value === false || value === null || typeof value === 'number' ) { return value; }
			value = parseFloat( value );
			return ( value || value === 0.0 ) ? value : null;
		};
		// normalize LOQ with LOD * ratio
		const calculateLOQ = function(lod, lod_loqRatio) {
			if ( ! lod_loqRatio || isNaN( lod ) ) { return null; }
			return lod * lod_loqRatio;
		};
		// Passes NaNs & other non-numbers through
		const toSigDigits = function( value, digits, lowerBound = null ) {
			let prefix = typeof value == 'string' && value[0] == '<' ? '<' : '';
			if ( prefix == '<')
				value = value.substr(1);
	
			if (value === '')
				return prefix;
	
			let asFloat = parseFloat( value );
			if ( isNaN( asFloat ) && (value == '<' || lowerBound == null) )
				return prefix + value;
	
			digits = parseInt( digits );
			if ( ( value == '<' || digits != null && lowerBound != null && asFloat < lowerBound && value != lowerBound ) ) {
				prefix = '<';
				value = lowerBound;
				asFloat = parseFloat( value );
			}
	
			if ( isNaN( digits ) )
				return prefix + value;
	
			if(value >= 1 && value <= 10) {
				return prefix + asFloat.toFixed(1);
			}
			else if (value > 10) {
				return prefix + asFloat.toFixed(0);
			}
			else if (value < 1) {
				return prefix + asFloat.toFixed(2);
			}
			
			value = asFloat;
			return prefix + ( ( typeof value != 'string' || value.indexOf('e') == -1 ) ? value : asFloat.toString() );
		}
	
		// Used for parameter translation for extracting test and method
		function combos( inputs, outputsCombos = [[]] ) {
			if ( inputs.length == 0 ) { return outputsCombos; }
			const last = inputs.pop();
			const nullCombos = outputsCombos.map( c => [ null ].concat( c ) );
			return combos( inputs, ( last != null && last != undefined )
				? outputsCombos.map( c => [ last ].concat( c ) ).concat( nullCombos )
				: nullCombos );
		}
	
		function getTestDefaultMethod( testID ) {
			const test = LocalStorageManager.get( 'testList' ).find( t => t.id == testID );
			return ( test  ? test.method : null );
		}
	
		function toUppercaseIfString( value ) { return typeof value == 'string' ? value.toUpperCase() : value; }
	
		class DbResultInfo {
			constructor( row = {} ) {
				this.SampleNumber = parseInt( row.SampleNumber ) || null;
				this.SampleDescription = row.SampleDescription || null;
				this.ResultID = null != row.ResultID ? parseInt( row.ResultID ) : null;
				if ( isNaN( this.ResultID ) || ( ! ( 0 < this.ResultID ) && null !== this.ResultID ) ) {
					this.ResultID = null;
				}
				this.ClientID = parseInt( row.ClientID ) || null;
				this.ClientName = row.ClientName || null;
				this.TestID = parseInt( row.TestID ) || null;
				this.DissolvedOrTotal = row.DissolvedOrTotal || null;
				this.ResultStandardDeviations = parseFloat( row.ResultStandardDeviations ) || null;
				this.DNRPAL = row.DNRPAL !== undefined ? row.DNRPAL : null;
				this.DNRES = row.DNRES !== undefined ? row.DNRES : null;
				this.DNRMethod = row.DNRMethod !== undefined ? row.DNRMethod : null;
				this.DNRUnits = row.DNRUnits !== undefined ? row.DNRUnits : null;
			}
			matches( row ) {
				return row.SampleNumber == this.SampleNumber && row.TestID == this.TestID;
			}
			mergeInto( row ) {
				row.SampleExists = this.SampleNumber != null;
				row.SampleDescription = this.SampleDescription;
				row.ClientID = this.ClientID;
				row.ClientName = this.ClientName;
				row.DissolvedOrTotal = this.DissolvedOrTotal;
				row.DNRPAL = this.DNRPAL;
				row.DNRES = this.DNRES;
				row.DNRMethod = this.DNRMethod;
				row.DNRUnits = this.DNRUnits;
				if ( row.TestID == this.TestID ) {
					row.ResultID = this.ResultID;
					row.ResultStandardDeviations = this.ResultStandardDeviations;
				}
				return row;
			}
			static mergeEmptyInto( row ) { return new DbResultInfo().mergeInto( row ); }
			static mergeFromInto( results, row ) {
				let bestResult = null;
				for ( let result of results ) {
					if ( result.SampleNumber != row.SampleNumber ) continue;
					if ( bestResult == null )
						bestResult = result;
					else if ( result.TestID == row.TestID ) {
						bestResult = result;
						break;
					}
				}
				return (bestResult !== null ? bestResult : new DbResultInfo() ).mergeInto( row );
			}
		}
	
		const compareBySampleNumber = ( a, b ) => a.SampleNumber - b.SampleNumber;
		const compare = ( a, b ) => a.SampleNumber != b.SampleNumber
			? a.SampleNumber - b.SampleNumber
			: a.ResultID != b.ResultID
			? a.ResultID - b.ResultID
			: a.Analyte > b.Analyte
			? 1
			: a.Analyte < b.Analyte
			? -1
			: 0;
	
		const defaultSampleNumberDigits = 8;
	
		const fields = [
			{
				label: 		'Sample Number',
				columnName: 'SampleNumber',
				type:       'sample-link',
			},
			{
				label: 		'Sample ID',
				columnName: 'SampleDescription',
				type:       'sample-link',
			},
			{
				label: 		'Test Name',
				columnName: 'TestID',
				isEditable: true,
				type:		'test',
				sort:		'asc',
				render: 	DataTablesManager.getTestNameByID,
			},
			{
				label: 		'Analyte',
				columnName: 'Analyte',
			},
			{
				label: 		'Result',
				columnName: 'Result',
				type: 		'result',
				isEditable:	true,
			},
			{
				label: 		'Units',
				columnName: 'Units',
				isEditable:	true,
				type:		'combobox',
				datalist:	'units'
			},
			{
				label: 		'QA Code',
				columnName: 'QAFlag',
				isEditable:	true,
			},
			{
				label: 		'Analyzed Date',
				columnName: 'AnalyzedDate',
				isEditable:	true,
				type:       'date',
			},
			{
				label: 		'Analyzed Time',
				columnName: 'AnalyzedTime',
				isEditable:	true,
			},
			{
				label: 		'LOD',
				columnName: 'LOD',
				isEditable:	true,
			},
			{
				label: 		'LOQ',
				columnName: 'LOQ',
				isEditable:	true,
			},
			{
				label:		'Dilution',
				columnName: 'Dilution',
				isEditable:	true,
			},
			{
				label:		'Method',
				columnName: 'Method',
				isEditable:	true,
			},
			{
				label:		'Analyst',
				columnName: 'Analyst',
				isEditable:	true,
			},
			{
				label:		'Client',
				columnName: 'ClientName',
				type:       'client-link',
			},
			{
				label:	    'Dissolved Or Total',
				columnName: 'DissolvedOrTotal',
				visible:    false,
			},
			{
				label:		'DNR PAL',
				columnName: 'DNRPAL',
				isEditable:	true,
			},
			{
				label:		'DNR ES',
				columnName: 'DNRES',
				isEditable:	true,
			},
		];
	
		const args = {
	
			tableId: 		'#data-table-import-results',
	
			// no DB tables
			ajax: 	false,
			paging: false,
	
			primaryKey: 	'ID',
	
			hasColumnSearch: false,
			canSort:         true,
			actionEdit:      true,
			actionRemove:    true,
			drawWhen:        false,
	
			fields: fields,
	
			createdRow: function( row, data, index ) {
				if ( data.SampleExists === false || ( ! (0 < data.ResultID) && ! data.ParentID ) ) {
					row.setAttribute('class', 'alert-warning');
				}
			}
		};
		init.setDataTableArgs( args );
		let hooked = false;
		let settings = { testLod_loqRatio: 3.33 };
		function hook() {
			if ( hooked ) return;
			hooked = true;
			const dataTable = tab.getDataTable();
			dataTable.editor().on( 'edit', function(e, json, data) {
				const editData = this.s.editData;
				for ( const row of json.data ) {
					if ( editData.LOD[ row.ID ] != row.LOD ) {
						dataTable.rows().every( function(rowIdx, tableLoop, rowLoop) {
							var d = this.data();
							if ( d.ID != row.ID )
								return;
							const testMethodLimits = LocalStorageManager.get( 'testMethodLimitsMap' );
							const limits = ( row.Method && testMethodLimits[ JSON.stringify( [ row.TestID, row.Method ] ) ] )
								|| testMethodLimits[ JSON.stringify( [ row.TestID, null ] ) ]
								|| { lod: null, loq: null, lod_loqRatio: null };
	
							const places = row.LOD.indexOf('.');
							const ratio = coalesce( limits.lod_loqRatio, settings.testLod_loqRatio, 3.33 );
							const LOQ = parseFloat(row.LOD) * ratio;
							row.LOQ = d.LOQ = isNaN( LOQ ) ? d.LOQ : LOQ.toFixed( places == -1 ? 0 : row.LOD.length - places - 1 );
							this.invalidate(); // invalidate the data DataTables has cached for this row
						} );
					}
				}
				dataTable.draw();
			} );
		}
	
		const tab = this;
		init.setController( new TabControllerVue({
			el: '#import-results-datatable-filters',
			computed: {
				tests: function() {
					const head = this.importType && this.importType.settings.some( settings => settings.testID == null ) ? [ { id: null, testName: null } ] : [];
					return head.concat( LocalStorageManager.get( 'testList' )
						.filter( test => this.importType && this.importType.settings.find( settings => settings.testID == test.id ) ) );
				},
				testMethodLimits: function() {
					return LocalStorageManager.get( 'testMethodLimitsMap' );
				},
				importParameterTranslationMap: function() {
					return LocalStorageManager.get( 'importParameterTranslationMap' );
				},
			},
			methods: {
				resetData() {
					this.hasResults   = false;
					this.nextID       = 0;
					this.importTypes  = [];
					this.dataTable    = null;
					this.importType   = null;
					this.test         = null;
					this.settings     = null;
					this.samplePrefix = null;
					this.lod          = null;
					this.dilution     = null;
					this.analyst      = null;
					this.analyzedDate = null;
					this.analyzedTime = null;
	
					this.sampleNumberDigits = defaultSampleNumberDigits;
					this.sampleNumberBase   = 0;
					this.outlierStandardDeviationRatio = null;
				},
				onOpenTab() {
					this.analyzedDate = getLocalISODate();
					const _this = this;
					window.ajaxCall({
						data : {
							action: 'get_import_types',
						},
						onSuccess : function( { data } ) {
							const types = [];
							data.forEach( row => {
								const text = row.text;
								delete row.text;
								const type = types.find( type => type.text == text );
								if ( type ) {
									type.settings.push( row );
								} else {
									types.push( {
										id: types.length,
										text,
										settings: [ row ],
									} );
								}
							} );
							_this.importTypes = types;
						},
					});
				},
				requestFile: function( event ) {
					let target = event.target;
					// ignore click on file input itself
					if ( target.type === 'file' ) { return; }
					while ( target ) {
						const fileInput = Array.prototype.find.call( target.getElementsByTagName('input'), input => input.type == 'file' );
						if ( fileInput ) {
							fileInput.click();
							return;
						}
						target = target.parentElement;
					}
				},
				translate: function( inParameter, inTest, inMethod, preOrder, postOrder, extract, fallback ) {
					const ucImportType = this.importType ? toUppercaseIfString( this.importType.text ) : null;
					const ucInParameter = toUppercaseIfString( inParameter );
					const ucInTest = toUppercaseIfString( inTest );
					const ucInMethod = toUppercaseIfString( inMethod );
					const inArray = preOrder( ucImportType, ucInParameter, ucInTest, ucInMethod );
					const keys = combos( inArray ).map( postOrder ).map( JSON.stringify );
					for ( let i = 0; i < keys.length; ++i ) {
						const fields = this.importParameterTranslationMap[ keys[i] ];
						if ( fields ) {
							const field = extract( fields );
							if ( field ) {
								return field;
							}
						}
					}
					return typeof fallback == 'function'
						? fallback( ucImportType, ucInParameter, ucInTest, ucInMethod )
						: fallback;
				},
				translateTest: function(inParameter, inTest, inMethod) {
					return this.translate(
						inParameter,
						inTest,
						inMethod,
						(importType, parameter, test, method) => [ importType, parameter, test, method ],
						combo => combo,
						fields => fields.testID,
						(ucImportType, ucParameter, ucTestName, ucMethod) => {
							const test = LocalStorageManager.get( 'testList' ).find( t => t.testName.toUpperCase() == ucTestName );
							return test ? parseInt( test.id ) : null;
						}
					);
				},
				translateMethod: function(inParameter, inTest, inMethod) {
					return this.translate(
						inParameter,
						inTest,
						inMethod,
						(importType, parameter, test, method) => [ importType, parameter, method, test ],
						combo => [ combo[0], combo[1], combo[3], combo[2] ],
						fields => fields.method,
						inMethod
					);
				},
				normalizeEntry: function( { SampleNumber, SampleDescription, Result, Parameter, TestName, Method, LOD, LOQ, Units, Dilution, AnalyzedDate, Analyst, Flags, Analyte, AnalyzedTime } ) {
					const sampleNumberMatch = (this.settings.stripSampleNumber ? /[0-9]+ *$/ : /^ *[0-9]+ *$/ ).exec( SampleNumber );
					const testID = this.translateTest( Parameter, TestName, Method ) || ( this.test ? this.test.id : null );
					const method = this.translateMethod( Parameter, TestName, Method ) || getTestDefaultMethod( testID );
					const limits = ( method && this.testMethodLimits[ JSON.stringify( [ testID, method ] ) ] )
						|| this.testMethodLimits[ JSON.stringify( [ testID, null ] ) ]
						|| { lod: null, loq: null, lod_loqRatio: null };
					const lod = normalizeNumber( coalesce( LOD, limits.lod, this.lod ) );
					const outRow = {
						ID: this.nextID++,
						SampleNumber: sampleNumberMatch && sampleNumberMatch.length
							? this.sampleNumberBase + parseInt( sampleNumberMatch[0] )
							: null,
						SampleDescription: emptyCoalesce( SampleDescription ),
						TestID:       parseInt( testID ) || null,
						Method:       method,
						Analyte,
						Result:       toSigDigits( Result, this.settings.decimalPlaces, lod ),
						Units,
						QAFlag:       Flags,
						AnalyzedDate: emptyCoalesce( excelFieldToDate( AnalyzedDate ), this.analyzedDate ),
						AnalyzedTime,
						LOD:          toSigDigits( lod, this.settings.decimalPlaces ),
						LOQ:          toSigDigits(
							LOQ != null
								? LOQ
								// if row has LOD or using LOD input or limits.loq is nothing
								: LOD != null || ( limits.lod == null && this.lod != null ) || limits.loq == null
								? calculateLOQ( lod, coalesce( limits.lod_loqRatio, this.settings.testLod_loqRatio, 3.33 ) )
								: limits.loq,
							this.settings.decimalPlaces
						),
						Dilution,
						Analyst,
						DecimalPlaces: this.settings.decimalPlaces,
					};
					return outRow;
				},
				extractResult: function( row ) {
					const lessThan = getFieldByIndex( row, this.settings.lessThanIndex );
					const prefix = typeof lessThan == 'string' && lessThan.includes( '<' ) ? '<' : '';
					let index = this.settings.resultIndex;
					let result = getFieldByIndex( row, index );
					if ( result == null || result.length == 0 ) {
						index = this.settings.numericResultIndex;
						result = getFieldByIndex( row, index );
					}
					if ( typeof result == 'string' && this.settings.flagsIndex == index ) {
						const slashIndex = result.indexOf('/');
						if ( slashIndex > -1 )
							result = result.substr( 0, slashIndex );
					}
					return prefix + result;
				},
				removeLessThan: function( flags ){
					if ( this.settings.flagsIndex == this.settings.lessThanIndex ) {
						return flags.replace(/((^\s*)?<\s*,\s*)|(,?\s*<)/, '').trim();
					}
					return flags;
				},
				extractFlags: function( row ) {
					let flags = getFieldByIndex( row, this.settings.flagsIndex );
					if ( this.settings.flagsIndex != this.settings.resultIndex ) { return flags; }
					if ( typeof flags != 'string' ) { return null; }
					const offset = flags.indexOf('/') + 1;
					return offset ? this.removeLessThan( flags.substr( offset ) ) : null;
				},
				fromRow: function( row ) {
					return {
						SampleNumber:  getFieldByIndex( row, this.settings.sampleNumberIndex ),
						Result:        this.extractResult( row ),
						TestName:      getFieldByIndex( row, this.settings.testIndex ),
						LOD:           getFieldByIndex( row, this.settings.lodIndex ),
						LOQ:           getFieldByIndex( row, this.settings.loqIndex ),
						Dilution:      getFieldByIndex( row, this.settings.dilutionIndex, this.dilution ),
						Analyst:       getFieldByIndex( row, this.settings.analystIndex, this.analyst ),
						AnalyzedDate:  getFieldByIndex( row, this.settings.dateAnalyzedIndex, this.dateAnalyzed ),
						AnalyzedTime:  getFieldByIndex( row, this.settings.timeAnalyzedIndex, this.timeAnalyzed ),
						Units:         getFieldByIndex( row, this.settings.unitsIndex, this.settings.testPreferredUnits),
						Method:        getFieldByIndex( row, this.settings.methodIndex ),
						Parameter:     getFieldByIndex( row, this.settings.parameterIndex ),
						Analyte:       getFieldByIndex( row, this.settings.analyteIndex ),
						Flags:         this.extractFlags( row ),
					};
				},
				upload: function( event ) {
					tab.drawTable();
					// Show processing indcator
					document.getElementById('data-table-import-results_processing').style = "";
	
					const input = event.target;
					if ( input.files.length == 0 ) { return }
					const _this = this;
					readXlsxFile(input.files[0], { dateFormat: 'YYYY-MM-DD' }).then(function(data) {
						const processedData = [];
						function addRow( row ) {
							if ( row.LOD == null || row.LOD == '' ) { row.LOD = _this.lod; }
							if ( row.Dilution == null || row.Dilution == '' ) { row.Dilution = _this.dilution; }
							processedData.push( row );
						}
						// Collect data spanning after sample number
						let baseRow = null;
						for ( let i = 0; i < data.length; ++i ) {
							const curRow = _this.fromRow( data[ i ] );
							if ( curRow.SampleNumber != null && curRow.SampleNumber != '' ) {
								if ( baseRow != null ) {
									addRow( baseRow );
								}
								baseRow = curRow;
								continue;
							} else if ( baseRow == null ) {
								continue;
							}
							if ( ( baseRow.Result == null || baseRow.Result == '' || baseRow.Result == 'null' )
								&& curRow.Result != null && curRow.Result != '' && curRow.Result != 'null' ) {
									baseRow.Result = curRow.Result;
								}
							if ( ( baseRow.LOD == null || baseRow.LOD == '' ) && curRow.LOD != null && curRow.LOD != '' ) {
								baseRow.LOD = curRow.LOD;
							}
							if ( ( baseRow.Dilution == null || baseRow.Dilution == '' )
								&& curRow.Dilution != null && curRow.Dilution != '' ) {
									baseRow.Dilution = curRow.Dilution;
								}
							if ( ( baseRow.Flags == null || baseRow.Flags == '' )
								&& curRow.Flags != null && curRow.Flags != '' ) {
									baseRow.Flags = curRow.Flags;
								}
						}
						if ( baseRow != null ) {
							addRow( baseRow );
						}
						_this.hasResults = false;
						args.dataTable.clear();
						const sampleNumbersAndTests = new Set();
						const hasNotDuplicate = function( row ) {
							const sampleNumber = parseInt( row.SampleNumber );
							if ( ! sampleNumber && sampleNumber !== 0 ) { return false; }
							const key = makeKey( row )
							if ( sampleNumbersAndTests.has( key ) ) { return false; }
							sampleNumbersAndTests.add( key );
							return true;
						}
						const sortedData = processedData
							.map( _this.normalizeEntry )
							.filter( hasNotDuplicate )
							.sort( compare );
	
						window.ajaxCall({
							data : {
								action: 'match_imported_results',
								sampleNumbersAndTestIDs: sortedData.map( row => [ row.SampleNumber, row.TestID ] ),
							},
							onSuccess : function( { data } ) {
								const dbData = data.map( row => new DbResultInfo( row ) );
								sortedData.forEach( row => {
									row = DbResultInfo.mergeFromInto( dbData, row )
									args.dataTable.row.add( row );
									if ( row.ResultID || row.ParentID ) { _this.hasResults = true; }
								} );
								args.dataTable.draw();
								hook();
	
								// Hide processing indcator
								document.getElementById('data-table-import-results_processing').style = "display:none";
							},
							onError : function( response ) {
								// Hide processing indcator
								document.getElementById('data-table-import-results_processing').style = "display:none";
	
								args.dataTable.clear().draw();
								_this.hasResults = false;
								alert( 'Could not look up results' );
							},
						});
					}, function (error) {
						console.error(error)
						alert("Error while parsing Excel file.")
					});
					input.value = null;
				},
				saveResults: function() {
					// Extract results for JSON export
					let resultSets = [];
					var results = null;
					const data = args.dataTable.rows().data();
					let uploaded = 0;
					for ( let i = 0; i < data.length; ++i ) {
						results = [];
						resultSets.push( results );
						const entry = data[i];
						if ( entry.SampleExists === false || ( ! (0 < entry.ResultID) && ! entry.ParentID ) ) { continue; }
						results.push( {
							SampleNumber:      entry.SampleNumber,
							TestID:            parseInt( entry.TestID ),
							Result:            entry.Result,
							Units:             entry.Units,
							QAFlag:            entry.QAFlag,
							AnalyzedDate:      entry.AnalyzedDate,
							AnalyzedTime: 	   entry.AnalyzedTime,
							LOD:               entry.LOD,
							LOQ:               entry.LOQ,
							Dilution:          entry.Dilution,
							Method:            entry.Method,
							Analyst:           entry.Analyst,
							Analyte:           entry.Analyte,
							ResultID:          entry.Analyte ? null : entry.ResultID,
							DissolvedOrTotal:  entry.DissolvedOrTotal,
							DecimalPlaces:     entry.DecimalPlaces,
							ParentID:          entry.ParentID !== undefined
								? entry.ParentID
								: ( entry.Analyte ? entry.ResultID : null ),
						} );
					}
					if ( resultSets.length == 0 ) { return; }
					(function doAjax( response = null) {
						if ( resultSets.length == 0 ) {
							args.dataTable.clear().draw();
							return;
						}
						const results = resultSets.shift();
						uploaded += results.length;
						window.ajaxCall( {
							loadingMessage: `Importing ${uploaded - results.length + 1} to ${uploaded} of ${data.length} results.`,
							loadingNoticeTimeout: 60 * 1000,
							successMessage: `Imported ${uploaded} of ${data.length} results.`,
							data : {
								action: 'import_results',
								results,
							},
							onSuccess : doAjax,
						} );
					})();
				},
				recalcSampleNumberBase: function() {
					const multipler = this.samplePrefix !== null
						? Math.pow( 10, this.sampleNumberDigits - this.samplePrefix.toString().length )
						: 0;
					this.sampleNumberBase = parseInt( this.samplePrefix ) * multipler;
				},
			},
			watch: {
				samplePrefix : function () { this.recalcSampleNumberBase() },
				sampleNumberDigits : function () { this.recalcSampleNumberBase() },
				importType : function( value ) {
					if ( ! value || (this.test && ! value.settings.some( settings => settings.testID == this.test.id )) ) {
						this.test = null
					}
					if ( ! this.test && value ) { this.test = this.tests[0] || null; }
				},
				test : function( value ) {
					settings = this.settings = this.importType && value && this.importType.settings.find( settings => settings.testID == value.id ) || null;
				},
			}
		}) );
	}
	
	} );
	